import '@testing-library/jest-dom';
import { render, screen } from '@testing-library/react';

import { Label } from './Label';

describe('Label', () => {
  it('should render', () => {
    render(<Label htmlFor="testComponent">Test label</Label>);
    expect(screen.getByText('Test label')).toBeInTheDocument();
  });

  it('should render with required', () => {
    render(
      <Label htmlFor="testComponent" required={true}>
        Test label
      </Label>
    );
    expect(screen.getByText('Test label')).toHaveClass('label--required');
  });

  it('should render with noFontWeight', () => {
    render(
      <Label htmlFor="testComponent" noFontWeight={true}>
        Test label
      </Label>
    );
    expect(screen.getByText('Test label')).toHaveClass('label--unset-font-weight');
  });

  it('should render with alignRight', () => {
    render(
      <Label htmlFor="testComponent" alignRight={true}>
        Test label
      </Label>
    );
    expect(screen.getByText('Test label')).toHaveClass('label--align-right');
  });
});
